import createIcon from '../../createIcon';

/**
 * @component @name Tram
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgMTYuOTRWOC41QzE5IDUuNzEgMTYuMzkgNS4xIDEyLjk5IDUuMDFMMTMuNzUgMy41SDE3VjJIN1YzLjVIMTEuNzVMMTAuOTkgNS4wMkM3Ljg2IDUuMTEgNSA1LjczIDUgOC41VjE2Ljk0QzUgMTguMzkgNi4xOSAxOS42IDcuNTkgMTkuOTFMNiAyMS41VjIySDguMjNMMTAuMjMgMjBIMTRMMTYgMjJIMThWMjEuNUwxNi41IDIwSDE2LjQyQzE4LjExIDIwIDE5IDE4LjYzIDE5IDE2Ljk0Wk0xMiAxOC41QzExLjE3IDE4LjUgMTAuNSAxNy44MyAxMC41IDE3QzEwLjUgMTYuMTcgMTEuMTcgMTUuNSAxMiAxNS41QzEyLjgzIDE1LjUgMTMuNSAxNi4xNyAxMy41IDE3QzEzLjUgMTcuODMgMTIuODMgMTguNSAxMiAxOC41Wk0xNyAxNEg3VjlIMTdWMTRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Tram = createIcon('Tram', [
  [
    'path',
    {
      d: 'M19 16.94V8.5C19 5.71 16.39 5.1 12.99 5.01L13.75 3.5H17V2H7V3.5H11.75L10.99 5.02C7.86 5.11 5 5.73 5 8.5V16.94C5 18.39 6.19 19.6 7.59 19.91L6 21.5V22H8.23L10.23 20H14L16 22H18V21.5L16.5 20H16.42C18.11 20 19 18.63 19 16.94ZM12 18.5C11.17 18.5 10.5 17.83 10.5 17C10.5 16.17 11.17 15.5 12 15.5C12.83 15.5 13.5 16.17 13.5 17C13.5 17.83 12.83 18.5 12 18.5ZM17 14H7V9H17V14Z',
      key: 'i0xa3e',
    },
  ],
]);

export default Tram;
